import { salonInfo, navItems } from "@/mocks/content";

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      className="relative py-12 md:py-16"
      style={{ background: "#050505", borderTop: "1px solid rgba(212,163,115,0.15)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-10">
          {/* Logo */}
          <div className="flex flex-col leading-none">
            <span
              className="text-[#D4A373] tracking-[0.3em] text-xs font-light mb-1"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              MENS SPA
            </span>
            <span
              className="text-white tracking-[0.15em] text-xl font-medium"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              REFINE
            </span>
          </div>

          {/* Nav */}
          <nav className="flex flex-wrap gap-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="text-white/40 hover:text-[#D4A373] text-xs tracking-widest transition-colors duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* SNS */}
          <div className="flex items-center gap-3">
            <a
              href={salonInfo.instagram}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center border border-white/10 hover:border-[#D4A373]/40 hover:text-[#D4A373] text-white/40 transition-all duration-300 cursor-pointer"
              aria-label="Instagram"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a
              href={salonInfo.line}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center border border-white/10 hover:border-[#D4A373]/40 hover:text-[#D4A373] text-white/40 transition-all duration-300 cursor-pointer"
              aria-label="LINE"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
              </svg>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-white/5 mb-6" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p
            className="text-white/20 text-xs"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            {salonInfo.address}
          </p>
          <p
            className="text-white/20 text-xs"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            &copy; {new Date().getFullYear()} REFINE MEN&apos;S SPA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
